import { NavLink, useNavigate } from "react-router-dom";
import { Button } from "./Button";

export function SideBar(){
	const navigate = useNavigate()
	return (
		<nav className="sidebar">
			<ul>
				<li><NavLink key="dashboard_nav" className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard" end>Home</NavLink></li>
				<li><NavLink  key="services_nav" className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard/services" >Service Tickets</NavLink></li>
				<li><NavLink  key="customers_nav" className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard/customers" >Customers</NavLink></li>
				{/* <li><NavLink  key="members_nav" className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard/members" >Members</NavLink></li> */}
				<li><NavLink  key="members_nav" className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard/subscription_history" >Subscription History</NavLink></li>
				<li><NavLink  key="vehicles_nav" className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard/vehicles">Vehicles</NavLink></li>
				{/* <li><NavLink className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard/subscriptions">Subscriptions</NavLink></li>
				<li><NavLink className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard/transactions">Transactions</NavLink></li>
				<li><NavLink className={({ isActive }) => isActive ? "active-nav" : ""} to="/dashboard/services">Services</NavLink></li> */}
			</ul>

			<Button
				label="Add a Customer"
				color="black"
				onClick={()=>{
					navigate("/dashboard/members/add_member")
				}}
			/>
			<Button
				label="Create a Ticket"
				color="blue"
				onClick={()=>{
					navigate("/dashboard/services/add_ticket")
				}}
			/>
		</nav>
	);
}